module.exports = __webpack_public_path__ + "static/media/1 24 noklene.05ccee6f.mp3";